import React from 'react'
import style from './Loader.less'

const Loader = () => {
  return (
    <div className={style.ellipsis}>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.jsx